<template>
  <div v-if="isBusy" class="spinner-centered"><b-spinner /></div>
  <div v-else>
    <!-- show empty state if there are no organization - no b-table just div with text  -->
    <div v-if="organizations.length === 0">
      <h2>Brak organizacji z obsługą tabletów</h2>
    </div>
    <!-- show b-table with organizations without actions  -->
    <div v-else>
      <h2>Organizacje z obsługą tabletów</h2>
      <b-table
        show-empty
        stacked="md"
        :busy.sync="isBusy"
        responsive
        :items="organizations"
        :fields="fields"
      >
        <template v-slot:cell(actions)="row">
          <b-button-group>
            <b-button class="btn-primary mr-1" size="sm" @click="showMoreForOrganization(row)"
              >Zobacz Więcej</b-button
            >
          </b-button-group>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'All-Tablets-Super-Admin',
  components: {},
  async mounted() {
    const vm = this
    await vm.getAllTabletOrganizations()
    vm.isBusy = false
  },
  data() {
    return {
      isBusy: true,
      organizations: [],
      fields: [
        { key: 'name', label: 'Nazwa' },
        { key: 'actions', label: 'Akcje' }
      ]
    }
  },
  computed: {},
  methods: {
    async getAllTabletOrganizations() {
      const vm = this
      const response = await vm.$http.post('e-zacma/tablets/get-organizations')
      vm.organizations = response.data
    },
    async showMoreForOrganization(row) {
      const vm = this
      console.log('ROW: ', row)
      await vm.$router.push({
        name: 'e-zacma-tablets-super-admin-organization',
        params: { id: row.item.scope_id }
      })
    }
  }
}
</script>

<style lang="scss">
.spinner-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
